module.exports = __webpack_public_path__ + "static/mentions_legales-6a43d18264b6bb7e030fc5f078b2e399.pdf";